import { BarChart3, Camera, BookOpen, User } from 'lucide-react';

export type TabId = 'score' | 'battle' | 'new' | 'learn' | 'me';

interface BottomNavProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  hasPendingChallenges?: boolean;
}

const tabs: { id: TabId; label: string; Icon: typeof BarChart3 }[] = [
  { id: 'score', label: 'Projects', Icon: BarChart3 },
  { id: 'new', label: 'Upload', Icon: Camera },
  { id: 'learn', label: 'Improve', Icon: BookOpen },
  { id: 'me', label: 'Progress', Icon: User },
];

export function BottomNav({ activeTab, onTabChange, hasPendingChallenges = false }: BottomNavProps) {
  return (
    <nav className="fixed bottom-4 left-0 right-0 z-50 px-4">
      <div className="max-w-lg mx-auto flex items-end justify-around px-2 py-2 pb-[calc(env(safe-area-inset-bottom)+0.5rem)] app-shell-panel">
        {tabs.map(({ id, label, Icon }) => {
          const isActive = activeTab === id;
          const isCenter = id === 'new';

          return (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={`relative flex flex-col items-center gap-0.5 py-2 px-3 transition-colors duration-200 ${
                isCenter ? '-mt-3' : ''
              }`}
            >
              {isCenter ? (
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center shadow-warm transition-all duration-200 ${
                    isActive
                      ? 'bg-rose text-white scale-105'
                      : 'bg-rose/90 text-white'
                  }`}
                >
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
              ) : (
                <div className="relative">
                  <Icon
                    className={`w-5 h-5 transition-colors duration-200 ${
                      isActive ? 'text-info' : 'text-ink-muted'
                    }`}
                    strokeWidth={isActive ? 2.2 : 1.5}
                    fill={isActive ? 'currentColor' : 'none'}
                  />
                  {id === 'battle' && hasPendingChallenges && (
                    <span className="absolute -top-1 -right-1.5 w-2 h-2 bg-rose rounded-full" />
                  )}
                </div>
              )}
              <span
                className={`text-[10px] font-sans transition-colors duration-200 ${
                  isActive ? 'text-info font-medium' : 'text-ink-muted'
                } ${isCenter ? 'mt-0.5' : ''}`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
